import * as React from 'react';
import { ExternalRenderer } from '../../ExternalRenderer';
export const CustomSettingsPanelView = (props) => {
    return (React.createElement(ExternalRenderer, { render: props.settingsPanel.render, componentName: props.settingsPanel.name, frameworkComponent: props.settingsPanel.frameworkComponent }));
};
